module.exports = __webpack_public_path__ + "img/1.85bc0ef0.jpg";